/**
 * Pure view rules for insight cards, shared so the server's test runner can
 * pin behaviour the client has no runner for.
 *
 * Two of these exist because of the `kind` column's history: rows written
 * before it existed are backfilled by the same rule `kindOf` applies at read
 * time, and the words below are the single source for both the SQL backfill
 * (as a LIKE list) and the guard's kicker regex. If the two ever disagree, a
 * card the guard treats as macro could be featured as a fund card.
 */
/**
 * Kicker words that mean "this card is about the outside world". Lower-case,
 * matched as substrings. The guard builds its regex from this list; the
 * migration backfill mirrors it as `LIKE '%word%'` clauses.
 */
export const MACRO_KICKER_WORDS = Object.freeze([
    'sentimen',
    'global',
    'makro',
    'kebijakan',
    'moneter',
    'pasar',
    'tekanan',
    'katalis',
    'suku bunga',
    'bi-rate',
    'bi rate',
    'fed',
    'yield',
]);
export function isMacroKicker(kicker) {
    const k = kicker.toLowerCase();
    return MACRO_KICKER_WORDS.some((w) => k.includes(w));
}
/**
 * The one fallback rule for a card whose `kind` is null: cited → macro; a
 * macro-sounding kicker → macro; otherwise fund.
 */
export function kindOf(card) {
    if (card.kind)
        return card.kind;
    if (card.citations.length > 0)
        return 'macro';
    return isMacroKicker(card.kicker) ? 'macro' : 'fund';
}
/**
 * Newest published card per kind. Two published cards of one kind can coexist
 * until the next publish supersedes the older (supersede-by-kind only fires on
 * publish), so the reader must never see both: the newer wins here.
 */
export function pickFeatured(cards) {
    const out = { macro: null, fund: null };
    const stamp = (c) => c.publishedAt ?? c.generatedAt;
    for (const card of cards) {
        const kind = kindOf(card);
        const current = out[kind];
        if (!current || stamp(card) > stamp(current) || (stamp(card) === stamp(current) && card.id > current.id)) {
            out[kind] = card;
        }
    }
    return out;
}
//# sourceMappingURL=insightsView.js.map